/** @format */

import './App.css';
import Home from './Pages/Home';
import Loading from './Pages/Loading';
import FirstReDirect from './Pages/FirstReDirect';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import FreeBoard from './Pages/FreeBoard';
import BoardEdit from './Pages/BoardEdit';
import BoardItemDetail from './Pages/BoardItemDetail';
import Profile from './Pages/Profile';
import LocationMap from './Pages/LocationMap';
import Award from './Pages/Award';
import Rank from './Pages/Rank';

function App() {
  // console = {};
  // console.log = function () {}; //콘솔로그 제거
  // console.warn = function () {}; //콘솔경고제거
  // console.error = function () {}; //콘솔에러제거

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={<FirstReDirect />}
        />
        <Route
          path="/Loading"
          element={<Loading />}
        />
        <Route
          path="/Home"
          element={<Home />}
        />
        <Route
          path="Profile"
          element={<Profile />}
        />
        <Route
          path="Location"
          element={<LocationMap />}
        />
        <Route
          path="/Award"
          element={<Award />}
        />
        <Route
          path="/rank"
          element={<Rank />}
        />
        <Route
          path="Board"
          element={<FreeBoard />}
        />
        <Route
          path="Board/:id"
          element={<BoardItemDetail />}
        />
        <Route
          path="/BoardEdit"
          element={<BoardEdit />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
